import Product from 'cpc-license-manager/models/product';
import { belongsTo } from '@ember-data/model';

class Evision extends Product {
  @belongsTo('evision-feature', { async: false, inverse: null, embedded: true }) features;

  name = 'evision';
  label = 'eVision';

  get featuresJson() {
    return {
      numberOfCameras: this.features.numberOfCameras,
      reporting: this.features.reporting,
    };
  }
}

export default Evision;
